module.exports = {
      id: "health-usage",
      viewBox: "0 0 26.46 26.46",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#health",
      toString: function () {
        return this.url;
      }
    }